import React from 'react';

const ResetZoomButton = ({ onClick }) => {
  // Check if we're on mobile (screen width <= 768px)
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
  const bottomPosition = isMobile ? '180px' : '110px';

  return (
    <button
      onClick={onClick}
      title="Reset map view and close popups"
      style={{
        position: 'fixed',
        bottom: bottomPosition, // Responsive: 220px on mobile, 110px on desktop
        left: '50%',
        transform: 'translateX(-50%)', // Center horizontally
        zIndex: 1001,
        backgroundColor: 'white',
        border: '2px solid #ccc',
        borderRadius: '6px',
        padding: '8px 12px',
        fontSize: '14px',
        fontWeight: 'bold',
        cursor: 'pointer',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = '#f0f0f0';
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = 'white';
      }}
    >
      Reset View
    </button>
  );
};

export default ResetZoomButton;
